<template>
<div class="chapter">
<div class="inner_page">
<h1>The Big Book of Gross Stuff</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">A Note on the Writing of this Book</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">What Makes It Gross?</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch03">Gross Quiz!</a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">The Miracle of Birth</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">The Stream of Life</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Animals!</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Breaking the Wind</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Monsters! </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample">Everyone Poops</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch10" title="Link target outside of Sample">It’s a Gross Job, But I Don’t Want to Do It!</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch11" title="Link target outside of Sample">Toilets!</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch12" title="Link target outside of Sample">Putting Your Best Food Forward</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch13" title="Link target outside of Sample">Sewers!</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch14" title="Link target outside of Sample">Gross Anatomy</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch15" title="Link target outside of Sample">It’s a Gross World, After All!</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch16" title="Link target outside of Sample">The Skin You’re In</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch17" title="Link target outside of Sample">Food, Drink, and Other Harmless Hazards</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch18" title="Link target outside of Sample">Kicking the Bucket</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch19" title="Link target outside of Sample">Epilogue</span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch20" title="Link target outside of Sample">Bibliography</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01toc.vue?a807b9ee